import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { accountUpgradeFetcher } from "../../../api/requests";
import { useToaster } from "../../../context/toaster";
import { baseURL } from "../../../api/dataFetcher";
import "./TriStateCheckbox.css";
import LoadingIndicator from "../Loading/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faSave,
  faStop,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

function BasicTable({
  rows,
  cols = [
    "نام کانال",
    "مجموع ویدئوها",
    "مجموع بازدید",
    "مجموع لایک",
    "مجموع دیسلایک",
    "مجموع ذخیره",
    "مجموع اشتراک",
    "مجموع کامنت",
  ],
  name = "statistics",
  campaign = false,
  rowsLoading = false,
  setShowDelModal,
  setSelectedComment,
  setCommentState,
  onCommentStateChange,
  onChildCommentStateChange,
  handleSaveCancel,
  handleChildSaveCancel,
  setShowSaveModal,
  setUserSave,
  setRows,
  setSelectedRequest,
}) {
  const [userRows, setUserRows] = useState(rows);
  const [loading, setLoading] = useState(false);
  const [chosenUsers, setChosenUsers] = useState(null);
  const { addMessage } = useToaster();
  const [permission, setPermission] = useState(null);

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type,
      text,
    });
  };

  const handleCheckboxChange = (index) => {
    const updatedRows = userRows.map((user, i) => {
      if (i === index) {
        let nextState;
        if (user.is_approved === true) nextState = null;
        else if (user.is_approved === null) nextState = false;
        else nextState = true;

        return { ...user, is_approved: nextState };
      }
      return user;
    });

    setUserRows(updatedRows);
    const chosenItem = {
      id: updatedRows[index].id,
      is_approved: updatedRows[index].is_approved,
    };
    setChosenUsers(chosenItem);
  };

  const handleClick = async () => {
    if (!chosenUsers) return;
    setLoading(true);

    try {
      const res = await accountUpgradeFetcher.approve(
        chosenUsers.id,
        chosenUsers.is_approved
      );
      if (res.message) showToast("success", res.message);
    } catch (err) {
      console.error(err);
      showToast("error", "خطایی رخ داد. لطفا دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  const handleStaffToggle = (index, field) => {
    // const updated = userRows.map((user, i) => {
    //   if (i === index && field === "staff")
    //     return { ...user, is_staff: !user.is_staff };
    //   if (i === index && field === "supervisor")
    //     return { ...user, is_supervisor: !user.is_supervisor };
    //   if (i === index && field === "superuser")
    //     return { ...user, is_superuser: !user.is_superuser };
    //   return user;
    // });
    // setUserRows(updated);
    // setRows(updated)
  };

  return (
    <div className="table-responsive">
      {chosenUsers?.id && (
        <Button
          variant="success mb-2"
          type="button"
          style={{
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            fontSize: "14px",
            padding: "2px 5px",
            borderRadius: "2px",
          }}
          onClick={handleClick}
          disabled={loading}
        >
          {loading ? "در حال ارسال..." : "ذخیره"}
        </Button>
      )}

      <div className="table-container">
        <Table
          className="basicTable"
          style={{ textAlign: "center" }}
          striped
          bordered
          hover
        >
          <thead>
            <tr>
              {cols.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowsLoading && (
              <tr>
                <td colSpan={cols.length}>
                  <LoadingIndicator />
                </td>
              </tr>
            )}

            {!rowsLoading &&
              name === "viewStatistics" &&
              [...rows]
                .sort((a, b) => b.countedView - a.countedView)
                .map((item, index) => (
                  <tr key={index}>
                    <td>
                      <a
                        href={`/single-channel/${item.channelId}/`}
                        className="video-page text-primary"
                      >
                        {item.channelName}
                      </a>
                    </td>
                    <td>
                      <a
                        href={`/video-page/${item.videoId}/`}
                        className="video-page text-primary"
                      >
                        {item.title}
                      </a>
                    </td>
                    <td>{item.countedView}</td>
                  </tr>
                ))}

            {!rowsLoading &&
              name === "interactionStatistics" &&
              rows.map((item, index) => (
                <tr key={index}>
                  <td>
                    <a
                      href={`/single-channel/${item.channelId}/`}
                      className="video-page text-primary"
                    >
                      {item.channelName}
                    </a>
                  </td>
                  <td>
                    <a
                      href={`/video-page/${item.videoId}/`}
                      className="video-page text-primary"
                    >
                      {item.title}
                    </a>
                  </td>
                  <td>{item.countedLike}</td>
                  <td>{item.countedDislike}</td>
                  <td>{item.countedShare}</td>
                  <td>{item.countedSave}</td>
                </tr>
              ))}

            {!rowsLoading &&
              name === "commentStatistics" &&
              rows.map((item, index) => (
                <tr key={index}>
                  <td>
                    <a
                      href={`/single-channel/${item.channel_id}/`}
                      className="video-page text-primary"
                    >
                      {item.channel_name}
                    </a>
                  </td>
                  <td>
                    <a
                      href={`/video-page/${item.video_id}/`}
                      className="video-page text-primary"
                    >
                      {item.video_title}
                    </a>
                  </td>
                  <td>{item.total_comments}</td>
                  <td>{item.approved_comments}</td>
                  <td>{item.pending_comments}</td>
                </tr>
              ))}

            {!rowsLoading &&
              name === "statistics" &&
              rows.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: campaign
                      ? item.campaign_status === true
                        ? "#effdefff"
                        : "#fff1f1ff"
                      : null,
                  }}
                >
                  <td>
                    <a
                      href={`/single-channel/${
                        campaign
                          ? item.campaign__id + "/?campaign=true"
                          : item.channel__id
                      }/`}
                      className="video-page text-primary"
                    >
                      {campaign ? item.campaign__name : item.channel__name}
                    </a>
                  </td>
                  <td>{item.all_post}</td>
                  <td>{item.all_view}</td>
                  <td>{item.all_like}</td>
                  <td>{item.all_dislike}</td>
                  <td>{item.all_save}</td>
                  <td>{item.all_share}</td>
                  <td>{item.all_comments}</td>
                  <td>{campaign ? item.senders_count : item.repost_count}</td>
                  <td>{item.subscribe_count}</td>
                  {campaign && <td>{item.all_rate}</td>}
                  {campaign && (
                    <td>
                      {item.campaign_status === true ? "فعال" : "غیرفعال"}
                    </td>
                  )}
                </tr>
              ))}

            {!rowsLoading &&
              name === "userManagement" &&
              userRows?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div
                      className={`custom-checkboxx ${
                        item.is_approved === true
                          ? "checked"
                          : item.is_approved === false
                          ? "error"
                          : "empty"
                      }`}
                      onClick={() => handleCheckboxChange(index)}
                    ></div>
                  </td>
                  <td>{item.user?.created_date}</td>
                  <td>{item.user?.id}</td>
                  <td>
                    <img
                      src={
                        item.user?.image
                          ? baseURL + item.user?.image
                          : "/img/s1.png"
                      }
                      alt="User"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                      }}
                    />
                  </td>
                  <td>{item.user?.first_name + " " + item.user?.last_name}</td>
                  <td>{item.user?.description}</td>
                  <td>{item.user?.province}</td>
                  <td>{item.user?.job}</td>
                  <td>{item.user?.education}</td>
                  <td>
                    <button
                      className="adminBtnDelete"
                      onClick={() => {
                        setShowDelModal(true);
                        setSelectedRequest(item?.id);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </td>
                </tr>
              ))}

            {!rowsLoading &&
              name === "users" &&
              userRows?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div
                      className={`custom-checkboxx ${
                        item.is_verified === true
                          ? "checked"
                          : item.is_verified === false
                          ? "error"
                          : "empty"
                      }`}
                    ></div>
                  </td>
                  <td>{item?.id}</td>
                  <td>
                    <img
                      src={
                        item.profile?.image
                          ? baseURL + item.profile?.image
                          : "/img/s1.png"
                      }
                      alt="User"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                      }}
                    />
                  </td>
                  <td>{item.username}</td>
                  <td>
                    {item.profile?.first_name + " " + item.profile?.last_name}
                  </td>
                  <td>
                    <div
                      onClick={() => {
                        handleStaffToggle(index, "superuser");
                        setUserSave(true);
                      }}
                      className={`custom-checkboxx ${
                        item?.is_superuser === true
                          ? "checked"
                          : item?.is_superuser === false
                          ? "error"
                          : "empty"
                      }`}
                    ></div>
                  </td>
                  <td>
                    <div
                      onClick={() => {
                        handleStaffToggle(index, "supervisor");
                        setUserSave(true);
                      }}
                      className={`custom-checkboxx ${
                        item.is_supervisor === true
                          ? "checked"
                          : item.is_supervisor === false
                          ? "error"
                          : "empty"
                      }`}
                    ></div>
                  </td>
                  <td>
                    <div
                      onClick={() => {
                        handleStaffToggle(index, "staff");
                        setUserSave(true);
                      }}
                      className={`custom-checkboxx ${
                        item.is_staff === true
                          ? "checked"
                          : item.is_staff === false
                          ? "error"
                          : "empty"
                      }`}
                    ></div>
                  </td>
                  <td>{item.group_permissions?.name}</td>
                  <td>{item.last_login}</td>
                  <td>{item.profile?.description}</td>
                  <td>{item.profile?.province}</td>
                  <td>{item.profile?.job}</td>
                  <td>{item.profile?.education}</td>
                </tr>
              ))}

            {rows?.length > 0
              ? !rowsLoading &&
                name === "comments" &&
                rows.map((item, index) => {
                  const children =
                    item?.replies ||
                    item?.children ||
                    item?.sub_comments ||
                    item?.subComments ||
                    [];

                  const groupBgColor = index % 2 === 0 ? "#ffffff" : "#f9f9f9";

                  return (
                    <React.Fragment key={`parent-${item?.id ?? index}`}>
                      {index > 0 && (
                        <tr key={`separator-${item?.id ?? index}`}>
                          <td
                            colSpan={cols.length}
                            style={{
                              padding: 0,
                              height: "3px",
                              backgroundColor: "#ccc",
                              borderTop: "2px solid #999",
                            }}
                          ></td>
                        </tr>
                      )}
                      <tr
                        key={`parent-row-${item?.id ?? index}`}
                        style={{ backgroundColor: groupBgColor }}
                      >
                        <td>
                          <div
                            className={`custom-checkboxx ${
                              item.confirm_to_comment === true
                                ? "checked"
                                : "error"
                            }`}
                            onClick={() => {
                              const newState =
                                item.confirm_to_comment === true ? false : true;

                              onCommentStateChange(index, newState);
                              setCommentState(newState);
                            }}
                          ></div>
                        </td>
                        <td>
                          {item.user?.first_name + " " + item.user?.last_name}
                        </td>
                        <td>{item.comment}</td>
                        <td>{item.created_date}</td>
                        <td
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "5px",
                          }}
                          onClick={() => setSelectedComment(item?.id)}
                        >
                          {item?.hasChanged ? (
                            <>
                              <button
                                className="adminBtnSave"
                                onClick={() => {
                                  setShowSaveModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faSave} />
                              </button>
                              <button
                                className="adminBtnDelete"
                                onClick={() => {
                                  handleSaveCancel(index);
                                }}
                              >
                                <FontAwesomeIcon icon={faBan} />
                              </button>
                            </>
                          ) : (
                            <button
                              className="adminBtnDelete"
                              onClick={() => {
                                setShowDelModal(true);
                                setSelectedComment(item?.id);
                              }}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          )}
                        </td>
                      </tr>

                      {Array.isArray(children) &&
                        children.map((child, cIndex) => (
                          <tr
                            key={`child-${item?.id ?? index}-${
                              child?.id ?? cIndex
                            }`}
                            style={{ backgroundColor: groupBgColor }}
                          >
                            <td style={{ paddingRight: "30px" }}>
                              <div
                                className={`custom-checkboxx ${
                                  child.confirm_to_comment === true
                                    ? "checked"
                                    : "error"
                                }`}
                                onClick={() => {
                                  const newState =
                                    child.confirm_to_comment === true
                                      ? false
                                      : true;
                                  setSelectedComment(child?.id);
                                  setCommentState(newState);
                                  onChildCommentStateChange(
                                    index,
                                    cIndex,
                                    newState
                                  );
                                }}
                              ></div>
                            </td>
                            <td
                              style={{
                                color: "#555",
                                paddingRight: "30px",
                                fontStyle: "italic",
                              }}
                            >
                              <span
                                style={{
                                  marginLeft: 8,
                                  color: "#007bff",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                ↳
                              </span>
                              {child.user?.first_name +
                                " " +
                                child.user?.last_name}
                            </td>
                            <td
                              style={{
                                color: "#444",
                                paddingRight: "30px",
                                fontStyle: "italic",
                              }}
                            >
                              {child.comment}
                            </td>
                            <td style={{ color: "#666", paddingRight: "20px" }}>
                              {child.created_date}
                            </td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "5px",
                              }}
                            >
                              {child?.hasChanged ? (
                                <>
                                  <button
                                    className="adminBtnSave"
                                    onClick={() => {
                                      setSelectedComment(child?.id);
                                      setShowSaveModal(true);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faSave} />
                                  </button>
                                  <button
                                    className="adminBtnDelete"
                                    onClick={() => {
                                      handleChildSaveCancel(index, cIndex);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faBan} />
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="adminBtnDelete"
                                  onClick={() => {
                                    setShowDelModal(true);
                                    setSelectedComment(child?.id);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  );
                })
              : !rowsLoading && (
                  <p style={{ padding: "12px 12px 0px 12px" }}>
                    نظری ثبت نشده است.
                  </p>
                )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default BasicTable;
